import styled from "styled-components";

export const StyledSearch = styled.div`
  // border: 1px solid #fff;
  max-width: 600px;
  width: 100%;
  margin: 30px auto;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
`;
